export const ERRORS = "ERRORS";

// auth
export const SET_SIGNUP_DATA = "SET_SIGNUP_DATA";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_USER_FRM_API = "SET_USER_FRM_API";
export const RESET_AUTH_STATE = "RESET_AUTH_STATE";
export const GET_COUNTRIES_DATA = "GET_COUNTRIES_DATA";
export const SET_STATES_OF_COUNTRY = "SET_STATES_OF_COUNTRY";

// user onboarding
export const SET_STORE_DETAILS = "SET_STORE_DETAILS";
export const RESET_ONBOARDING_STATE = "RESET_ONBOARDING_STATE";

// store setup
export const RESET_STORE = "RESET_STORE";
export const SET_ALL_STORES = "SET_ALL_STORES";
export const SET_BUSINESS_DETAILS = "SET_BUSINESS_DETAILS";
export const SET_BUSINESS_ADDRESS = "SET_BUSINESS_ADDRESS";
export const SET_ACTIVE_STORE_NUM = "SET_ACTIVE_STORE_NUM";
export const SET_CUSTOMER_LIST_STATUS = "SET_CUSTOMER_LIST_STATUS";

// loyalty types start
export const SET_LOYALTY_TYPE = "SET_LOYALTY_TYPE";
export const SET_CASHBACK_TYPE = "SET_CASHBACK_TYPE";
export const SET_PREV_CASHBACK_TYPE = "SET_PREV_CASHBACK_TYPE";
export const TOGGLE_BOTTOM_SHEET = "TOGGLE_BOTTOM_SHEET";

export const GET_BANNERS = "GET_BANNERS";
export const SET_ITEMS_MENU = "SET_ITEMS_MENU";
export const UPDATE_BONUS_DETAILS = "UPDATE_BONUS_DETAILS";
export const SET_STORES_EXCLUDE_ITEMS = "SET_STORES_EXCLUDE_ITEMS";
export const SET_STORES_MULTIPLE_BILL_ALERT = "SET_STORES_MULTIPLE_BILL_ALERT";
export const SET_STORES_CASHBACK_PERCENTAGE = "SET_STORES_CASHBACK_PERCENTAGE";
export const SET_ACTIVE_STEP_FOR_FRD_NOTIFY = "SET_ACTIVE_STEP_FOR_FRD_NOTIFY";
export const SET_STORES_EXCLUDE_PAYMENT_TYPES =
  "SET_STORES_EXCLUDE_PAYMENT_TYPES";
export const SET_ADVANCED_CASHBACK_SEED_DATA =
  "SET_ADVANCED_CASHBACK_SEED_DATA";

export const RESET_LOYALTY = "RESET_LOYALTY";
export const SET_LOYALTY_DATA = "SET_LOYALTY_DATA";
export const UPDATE_PREVIEW_DETAILS = "UPDATE_PREVIEW_DETAILS";

export const GET_LOYALTY_INSIGHTS = "GET_LOYALTY_INSIGHTS";
export const GET_LOYALTY_PERF_INSIGHTS = "GET_LOYALTY_PERF_INSIGHTS";
export const GET_LOYALTY_SCOREBOARD = "GET_LOYALTY_SCOREBOARD";
export const GET_LOYALTY_ACTIVITY = "GET_LOYALTY_ACTIVITY";
export const GET_LOYALTY_TIER_INSIGHTS = "GET_LOYALTY_TIER_INSIGHTS";
export const GET_LOYALTY_CUSTOMERS = "GET_LOYALTY_CUSTOMERS";

// loyalty types end

// cashier
export const SET_CASHIER_PARENT = "SET_CASHIER_PARENT";
export const SET_CURRENT_CASHIER = "SET_CURRENT_CASHIER";
export const SET_CURRENT_CASHIER_DATA = "SET_CURRENT_CASHIER_DATA";
export const SET_CASHIER_STORE_DETAILS = "SET_CASHIER_STORE_DETAILS";
export const SET_CURRENT_CASHIER_CREDITS = "SET_CURRENT_CASHIER_CREDITS";
export const SET_CURRENT_CUSTOMER = "SET_CURRENT_CUSTOMER";
export const SET_POINTS_ON_FIRST_ORDER = "SET_POINTS_ON_FIRST_ORDER";
export const SET_CUSTOMER_REDEEMABLE_REWARDS =
  "SET_CUSTOMER_REDEEMABLE_REWARDS";
export const SET_STORE_REWARDS = "SET_STORE_REWARDS";
export const SET_REDEEMED_DATA = "SET_REDEEMED_DATA";
export const GET_ALL_STORE_ORDERS = "GET_ALL_STORE_ORDERS";
export const NEXT_CUSTOMER_INITIALIZE = "NEXT_CUSTOMER_INITIALIZE";

// dashboard
export const SET_REPORT_STATUS = "SET_REPORT_STATUS";
export const GET_ACCOUNT_STATUS = "GET_ACCOUNT_STATUS";
export const GET_INSIGHT_1 = "GET_INSIGHT_1";
export const GET_SALES_DATA = "GET_SALES_DATA";
export const GET_ORDERS_DATA = "GET_ORDERS_DATA";
export const GET_POPULAR_TIME = "GET_POPULAR_TIME";
export const RESET_DASHBOARD_STATE = "RESET_DASHBOARD_STATE";
export const SET_GENERAL_DASH_STATS = "SET_GENERAL_DASH_STATS";
export const SET_UPCOMING_CELEBRATIONS = "SET_UPCOMING_CELEBRATIONS";
export const GET_POPULAR_ITEMS_AND_CATEGORIES =
  "GET_POPULAR_ITEMS_AND_CATEGORIES";
export const SET_ACTIVE_CUSTOMER_LIFECYCLE_TEMPLATES =
  "SET_ACTIVE_CUSTOMER_LIFECYCLE_TEMPLATES";

// customer Insights
export const SET_KYC_DATA = "SET_KYC_DATA";
export const RESET_CUST_STATE = "RESET_CUST_STATE";
export const SET_SNAPSHOT_DATA = "SET_SNAPSHOT_DATA";
export const SET_CUSTOMERS_LIST = "SET_CUSTOMERS_LIST";
export const GET_A_CUSTOMER_ACTIVITY = "GET_A_CUSTOMER_ACTIVITY";
export const SET_NEW_RETURN_LOST_CUST = "SET_NEW_RETURN_LOST_CUST";
export const SET_CUSTOMERS_ACTIVITY = "SET_CUSTOMERS_ACTIVITY";
export const GET_CUSTOMERS_SEGMENT = "GET_CUSTOMERS_SEGMENT";
export const GET_CUSTOMERS_TABLE_SEGMENT = "GET_CUSTOMERS_TABLE_SEGMENT";
export const GET_DYNAMINC_FILTER_VALUES = "GET_DYNAMINC_FILTER_VALUES";

// campaigns

export const GET_CAMPAIGNS_TEMPLATES = "GET_CAMPAIGNS_TEMPLATES";
export const SET_CAMPAIGN_TEMPLATE = "SET_CAMPAIGN_TEMPLATE";
export const RESET_CAMPS = "RESET_CAMPS";
export const SET_CAMP_STATE = "SET_CAMP_STATE";
export const INITIALIZE_CAMP_STATE = "INITIALIZE_CAMP_STATE";
export const SET_CAMP_SHORTLINK = "SET_CAMP_SHORTLINK";
export const SET_TOTAL_CUSTOMERS = "SET_TOTAL_CUSTOMERS";
export const SET_WA_CREDITS = "SET_WA_CREDITS";
export const SET_EMAIL_CREDITS = "SET_EMAIL_CREDITS";
export const SET_SMS_CREDITS = "SET_SMS_CREDITS";
export const RESET_CAMP_STATE = "RESET_CAMP_STATE";
export const SET_CAMP_LIST = "SET_CAMP_LIST";
export const SET_CAMP_DETAIL = "SET_CAMP_DETAIL";
export const SET_TEST_CAMP_SENT = "SET_TEST_CAMP_SENT";
export const SET_DRAFT_CAMPAIGNS = "SET_DRAFT_CAMPAIGNS";
export const SET_DRAFT_CAMP_FOR_MEMB = "SET_DRAFT_CAMP_FOR_MEMB";
export const SET_CAMP_PERF_OVERVIEW = "SET_CAMP_PERF_OVERVIEW";
export const SET_CAMPAIGNS_CUSTOMERS = "SET_CAMPAIGNS_CUSTOMERS";
export const SET_EXISTING_CAMPAIGNS = "SET_EXISTING_CAMPAIGNS";

// SHORT LINK
export const SET_SHORTLINK_DATA = "SET_SHORTLINK_DATA";
export const SET_UPDATED_CUST_DATA = "SET_UPDATED_CUST_DATA";
export const RESET_SHORTLINK_STATE = "RESET_SHORTLINK_STATE";
export const SET_TEMPLATE_SHORTLINK_DATA = "SET_TEMPLATE_SHORTLINK_DATA";

// POS
export const SET_VENDORS_LIST = "SET_VENDORS_LIST";
export const SET_VENDOR_SEED = "SET_VENDOR_SEED";
export const SET_ACTIVE_VENDOR = "SET_ACTIVE_VENDOR";
export const RESET_VENDOR_STATE = "RESET_VENDOR_STATE";

// Payments
export const SET_CREDITS = "SET_CREDITS";
export const SET_ACTIVE_PLAN = "SET_ACTIVE_PLAN";
export const GET_ALL_INVOICES = "GET_ALL_INVOICES";
export const SET_CREDITS_SEED = "SET_CREDITS_SEED";
export const SET_BILLING_DETAILS = "SET_BILLING_DETAILS";
export const RESET_PAY_STATE = "RESET_PAY_STATE";
export const SET_AUTO_PAY_CREDITS = "SET_AUTO_PAY_CREDITS";

// channels details
export const SET_CHANNEL_LEDGER = "SET_CHANNEL_LEDGER";
export const RESET_CHANNEL_STATE = "RESET_CHANNEL_STATE";
export const SET_CHANNEL_OVERVIEW = "SET_CHANNEL_OVERVIEW";
export const SET_CHANNEL_MSG_LOGS = "SET_CHANNEL_MSG_LOGS";
export const SET_CHANNEL_REFILL_HISTORY = "SET_CHANNEL_REFILL_HISTORY";
export const SET_CHANNEL_DELIVERY_STATUS = "SET_CHANNEL_DELIVERY_STATUS";

// channel settings
export const SET_TEMPLATES_SEED = "SET_TEMPLATES_SEED";
export const SET_CHANNEL_HEADERS = "SET_CHANNEL_HEADERS";
export const SET_WA_CUST_HEAD_BILL = "SET_WA_CUST_HEAD_BILL";
export const SET_WA_CUST_HEAD_DRAFT = "SET_WA_CUST_HEAD_DRAFT";
export const CLEAR_WA_CUST_HEADER_DRAFT = "CLEAR_WA_CUST_HEADER_DRAFT";
export const CLEAR_WA_CUST_HEADER_BILL = "CLEAR_WA_CUST_HEADER_BILL";

// Feedback
export const SEED_FEEDBACK = "SEED_FEEDBACK";
export const RESET_FB_STATE = "RESET_FB_STATE";
export const SET_FB_RES_DATA = "SET_FB_RES_DATA";
export const SET_FB_EDIT_SEEN = "SET_FB_EDIT_SEEN";
export const SET_NEG_FB_BETA_USERS = "SET_NEG_FB_BETA_USERS";
export const SET_FB_NEG_ACTION_MSG_SENT = "SET_FB_NEG_ACTION_MSG_SENT";
// Feedback Analytics
export const FEEDBACK_OVERVIEW = "FEEDBACK_OVERVIEW";
export const FEEDBACK_DAILY_RESPONSES = "FEEDBACK_DAILY_RESPONSES";
export const FEEDBACK_RATINGS_OVERTIME = "FEEDBACK_RATINGS_OVERTIME";

// Automated Campaigns
export const RESET_AUTO_CAMPS = "RESET_AUTO_CAMPS";
export const SET_AUTO_CAMP_DETAIL = "SET_AUTO_CAMP_DETAIL";
export const SET_TEMP_AUTO_CAMPAIGN = "SET_TEMP_AUTO_CAMPAIGN";
export const SET_AUTO_CAMP_SHORTLINK = "SET_AUTO_CAMP_SHORTLINK";
export const SET_ACTIVE_AUTO_CAMP_IDS = "SET_ACTIVE_AUTO_CAMP_IDS";
export const SET_AUTO_CAMPAIGN_DRAFTS = "SET_AUTO_CAMPAIGN_DRAFTS";
export const SET_AUTO_CAMPAIGN_TEMPLATE = "SET_AUTO_CAMPAIGN_TEMPLATE";
export const SET_AUTO_CAMPAIGN_OVERVIEW = "SET_AUTO_CAMPAIGN_OVERVIEW";
export const SET_AUTO_CAMPAIGN_TEMPLATES = "SET_AUTO_CAMPAIGN_TEMPLATES";
export const SET_AUTO_DRAFTED_CAMP_STATE = "SET_AUTO_DRAFTED_CAMP_STATE";
export const INIT_AUTO_DRAFTED_CAMP_STATE = "INIT_AUTO_DRAFTED_CAMP_STATE";
export const RESET_AUTO_DRAFTED_CAMP_STATE = "RESET_AUTO_DRAFTED_CAMP_STATE";
export const SET_AUTO_CAMPAIGNS_CUSTOMERS_LIST =
  "SET_AUTO_CAMPAIGNS_CUSTOMERS_LIST";

// product tour
export const RESET_TOUR_STATE = "RESET_TOUR_STATE";
export const UPDATE_PRODUCT_TOUR = "UPDATE_PRODUCT_TOUR";
export const COMPLETE_RESET_TOUR_STATE = "COMPLETE_RESET_TOUR_STATE";

// Groups

export const SET_GROUP = "SET_GROUP";
export const SET_TEAM_MEMBER = "SET_TEAM_MEMBER";
export const SET_GROUP_STORE = "SET_GROUP_STORE";
export const RESET_GROUP_STATE = "RESET_GROUP_STATE";
export const SET_GROUP_PERMISSIONS = "SET_GROUP_PERMISSIONS";
export const TOGGLE_SWITCH_STORE_POPUP = "TOGGLE_SWITCH_STORE_POPUP";

// QR Code
export const SET_QR_TEMPLATE = "SET_QR_TEMPLATE";
export const GENERATE_QR_CODE = "GENERATE_QR_CODE";
export const SET_QR_CODE_STATE = "SET_QR_CODE_STATE";
export const SET_QR_OBJECTIVES_DATA = "SET_QR_OBJECTIVES_DATA";

// B2C Referral
export const SET_B2C_STATE = "SET_B2C_STATE";
export const SET_B2C_BETA_USER = "SET_B2C_BETA_USER";

// For Demo Account
export const SWITCH_ACCOUNT_TYPE = "SWITCH_ACCOUNT_TYPE";

// For Whatsapp Chat
export const RESET_WHATSAPP_CHAT = "RESET_WHATSAPP_CHAT";
export const SET_WA_CHAT_CUSTOMERS = "SET_WA_CHAT_CUSTOMERS";
export const SET_WA_CURRENT_CUSTOMER = "SET_WA_CURRENT_CUSTOMER";
export const SET_WA_CHAT_PUSHER_CHANNEL = "SET_WA_CHAT_PUSHER_CHANNEL";
export const SET_WA_CUSTOMER_CHAT_HISTORY = "SET_WA_CUSTOMER_CHAT_HISTORY";
export const SET_WA_CUSTOMER_CONVERSATION_IDS =
  "SET_WA_CUSTOMER_CONVERSATION_IDS";

// For audience recommendation
export const SET_SELECTED_SEGMENT = "SET_SELECTED_SEGMENT";
export const SET_CUSTOMER_SEGMENTS = "SET_CUSTOMER_SEGMENTS";
export const RESET_SELECTED_SEGMENT = "RESET_SELECTED_SEGMENT";
export const SET_DASHBOARD_SEGMENTS = "SET_DASHBOARD_SEGMENTS";
export const RESET_AUDIENCE_REC_STATE = "RESET_AUDIENCE_REC_STATE";

// For membership
export const SET_MEMBERSHIP_DATA = "SET_MEMBERSHIP_DATA";
export const SET_BANK_DETAILS_FOR_MEMBERSHIP =
  "SET_BANK_DETAILS_FOR_MEMBERSHIP";
export const SET_MEMBERSHIP_TEAM_MEMBER = "SET_MEMBERSHIP_TEAM_MEMBER";
export const SET_PURCHASED_MEMBERSHIP_SHORTLINK_DATA =
  "SET_PURCHASED_MEMBERSHIP_SHORTLINK_DATA";
export const SET_SUBSCRIBED_MEMBERSHIPS = "SET_SUBSCRIBED_MEMBERSHIPS";
export const SET_BANK_DETAIL_BANNER = "SET_BANK_DETAIL_BANNER";
